export const toggleFullScreen = ({ nav }) => {
    if (window.innerWidth > 1200) {
        nav.setIsSidebar('wrapper toggled')
    }
}